/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import RootActions from 'store/actions';
import { UIState } from "store/types/ui.types";
import { createSlice } from "@reduxjs/toolkit";

const initialState: UIState = {
  toggle: undefined,
  toggleDialog: false, 
  type: undefined, 
  msg: "", 
  scrollY: 0, 
  backStyle: false, 
  title: '',
  currentTab: 0
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: RootActions.uiSliceActions
})

export const {
  toggleDialog,
  toggleNav,
  setBackStyle,
  setScrolling,
  setCurrentTab
} = uiSlice.actions;

export default uiSlice.reducer;